export const modal = (): Record<string, Record<string, number>> => ({
  '.elmo-layout__main-menu, .elmo-layout__main-header': {
    zIndex: 0,
  },
});

export const content = (): Record<string, Record<string, number>> => ({
  '.elmo-layout__main-header': {
    zIndex: 1,
  },
});
